import { AddMemberForm } from './AddMember.types';

export const addMemberFormDefaultValues: AddMemberForm = {
  address: null,
  email: '',
  firstName: '',
  isAddress: false,
  lastName: '',
  phone: '',
};
